import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import DisplayApiKeys from './components/DisplayApiKeys';
import { fetchApiKeysStart } from 'redux/user/actions';
import { currentUser } from 'redux/session/selectors';
import { selectUsersLoading, selectApiKeys } from 'redux/user/selector';
import { ApiKey } from 'redux/user/types';
import { DataTableSkeleton } from 'carbon-components-react';
import { FullHeaderLeftSideFullPanelLayout } from 'layouts/fullHeader.LeftSideFullPanel.layout';
import { removeAlertByGroup } from 'redux/alerts/actions';
import { useComponentMount } from 'utilities/hooks.util';

const ApiKeys: React.FC<RouteComponentProps<{}, any, any>> = () => {
  const dispatch: any = useDispatch();
  const apiKeys: Array<ApiKey> = useSelector(selectApiKeys);
  const isLoading: boolean = useSelector(selectUsersLoading);
  const user: any = useSelector(currentUser);

  useEffect(() => {
    dispatch(fetchApiKeysStart());
  }, [dispatch, user]);

  useComponentMount(() => {
    return () => {
      dispatch(removeAlertByGroup('DELETE_USER_APIKEY_GROUP'));
    };
  });

  return (
    <div id="UserApiKeys" data-testid="UserApiKeys">
      <FullHeaderLeftSideFullPanelLayout
        pageHeading="API keys"
        pageDescription="Manage the security credentials for your external system integrations"
        enableHeaderGlobalBar={true}
      >
        <div id="members__body-content1" className="members__body-content1">
          {isLoading ? (
            <DataTableSkeleton showHeader={false} />
          ) : (
            <div id="DisplayUsers" data-testid="DisplayUsers">
              <DisplayApiKeys apiKeys={apiKeys} data-testid="DisplayApiKeys" />
            </div>
          )}
        </div>
      </FullHeaderLeftSideFullPanelLayout>
    </div>
  );
};
ApiKeys.displayName = 'UserApiKeys';
export default ApiKeys;
